<template>
    <div class="wrap calc-container container">


        <step-panel
            :steps="steps"
            :activeStepIndex="activeStepIndex"
            >

        </step-panel>



        <calculator-step v-show="step.active"  v-for="(step, i) in steps"
                          :key="step.id"
                          :step="step"
                          :step-number="i+1"
                          :criteria="getStepCriteria(step.id)"
                          :is-cart="cartStepId === step.id"
                          >

            <template v-slot:buttons>
                <step-buttons
                        :step-id="step.id"
                        :prev-step-index="prevStepIndex"
                        :next-step-index="nextStepIndex"
                        :active-step-index="activeStepIndex"
                        :cart-step-id = "cartStepId"
                ></step-buttons>
            </template>

            <template v-if="step.id === modeStepId" v-slot:change-mode>
                <change-mode></change-mode>
            </template>

            <template v-if="step.id===cartStepId" v-slot:product-list>
                <product-list v-for="type in productTypes" :key="type" :type="type" :cart-step-id="cartStepId" :selected-criteria="selectedCriteria"></product-list>
            </template>

        </calculator-step>

        <br>



    </div>
</template>

<script>
    import StepPanel from './StepPanel';
    import StepButtons from './StepButtons.vue';
    import CalculatorStep from './CalculatorStep';
    import ProductList from './ProductList'
    import ChangeMode from './ChangeMode.vue';

    export default {
        data(){
            return {
                productTypes:['heating', 'reg'],
                cartStepId : 'product_list',
                modeStepId : 'calculation_mode'
            }
        },
        components : {
            CalculatorStep,
            ProductList,
            StepPanel,
            StepButtons,
            ChangeMode
        },
        computed : {
            steps(){
                return this.$store.getters.getSteps;
            },
            criteria(){
               return this.$store.getters.getCriteria;
            },
            activeStepIndex(){
                return  this.$store.getters.getActiveStepIndex;
            },
            nextStepIndex(){
                return this.steps[this.activeStepIndex+1];
            },
            prevStepIndex(){
                return this.steps[this.activeStepIndex-1];
            },
            selectedCriteria(){
                return this.$store.getters.getSelectedCriteria;
            },

        },
        methods : {
          getStepCriteria(stepId){
              return this.criteria.filter((criterion) => criterion.stepId === stepId)
          },

        },
        created(){
            this.$store.dispatch('getSteps');

            if(this.$store.getters.getActiveStepIndex === -1){
                this.$store.commit('setActiveStepByIndex',0)
            }

            this.$store.dispatch('getCriteria');

        },
        updated(){
            let active_step = this.$store.getters.getActiveStep;
            if(active_step.id === 'product_list'){
                this.$store.dispatch('getProducts');
            }
        }
    }
</script>
<style>
    @font-face {
        font-family: 'Uni Sans Heavy CAPS';
        src: url('./../assets/fonts/UniSansHeavyCAPS.otf');
        font-weight: 600;
    }



</style>
